module.exports = __webpack_public_path__ + "static/media/discord.936512f6.svg";